module.exports = __webpack_public_path__ + "static/profile_bike-707cc7176392d2a33e48e96df3329b85.jpg";